﻿//TN 20230705
import Image from "../image";
import ActivePage from "../activePage";

export default class DMSCostTrackingPage extends ActivePage {

    constructor() {
        super();
        this.dmsInfo = [];
        this.image = new Image();
    }

    init(addMode) {        
        this.dmsInfo = [{ DisclosureNumber: "", DisclosureTitle: "", DisclosureStatus: "" }];
        this.tabsLoaded = [];
        this.tabChangeSetListener();

        $(document).ready(()=> {
            if (addMode) {
                const caseNumber = this.getKendoComboBox("DisclosureNumber");
                
                if (caseNumber.value()) {
                    this.getKendoComboBox("CostType").input.attr("autofocus", "autofocus");
                }
                else {
                    caseNumber.input.attr("autofocus", "autofocus");
                }

            }
        });
    }
    
    tabChangeSetListener() {
        $('#costTrackingTab a').on('click', (e)=> {
            e.preventDefault();
            const tab = e.target.id;
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
        });
    }
    
    loadTabContent(tab) {
        switch (tab) {
            //case "costTrackingDetailDocumentsTab":
            //    $(document).ready(()=> {
            //        this.image.initializeImage(this);
            //    });
            //    break;

            case "costTrackingDetailCorrespondenceTab":
                $(document).ready(() => {
                    const grid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "":
                break;
        }
    }

    caseNumberSearchValueMapper(options) {
        $.ajax({
            url: this.caseNumberSearchValueMapperUrl,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });

    }

    caseNumberDetailValueMapper(options) {
        $.ajax({
            url: this.caseNumberDetailValueMapperUrl,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    afterInsert = (result) => {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            //pageHelper.handleEmailWorkflow(result);
        });
    }

    showDetails(result) {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            //pageHelper.handleEmailWorkflow(result);
        });
    }

    getDMSInfo(callback) {
        const caseNumber = this.getKendoComboBox("DisclosureNumber");

        this.cpiLoadingSpinner.show();
        $.get(caseNumber._form.data("dms-info-url"), { caseNumber: caseNumber.value() })
            .done((data)=> {
                this.cpiLoadingSpinner.hide();
                this.dmsInfo = data;

                if (typeof callback !== "undefined" && callback !== null) {
                    callback();
                }
            })
            .fail(function (e) {
                this.cpiLoadingSpinner.hide();
                pageHelper.showErrors(e);
            });
    }

    showDMSInfo(sender, caseNumber) {
        const elName = sender.element[0].name;
        const dmsInfo = this.dmsInfo.find(function (dmsInfo) {
            return dmsInfo.DisclosureNumber === caseNumber;
        });

        if (dmsInfo === undefined) {
            sender.value("");
            this.clearDMSInfo();
            return;
        }
        
        //populate agent only if blank
        const agent = this.getKendoComboBox("AgentID");
        if (agent.value() === "" && dmsInfo["AgentID"]) {
            const agentName = $(`#${agent.element[0].id}_Name`);

            agent.value(dmsInfo["AgentID"]);
            agent.element.trigger("change");
            agentName.val(dmsInfo["AgentName"]).trigger("change");
        }

        for (const property in dmsInfo) {
            let value = dmsInfo[property];
            const element = this.getElement(property);
            if (element.length > 0 && element[0].tagName.toLowerCase() === "input") {
                if (isNaN(value) && Date.parse(value))
                    value = pageHelper.cpiDateFormatToDisplay(new Date(value));

                element.val(value).trigger("change");
            }
        }
    }

    clearDMSInfo () {      
        for (const property in this.dmsInfo[0]) {
            const element = this.getElement(property);
            if (element.length > 0 && element.data("role") !== "combobox") {
                element.val("").trigger("change");
            }
        }
    }

    onCaseNumberChange = (caseNumber)=> {
        this.cpiStatusMessage.hide();
        if (caseNumber.value()) {
            if (caseNumber.selectedIndex === -1) {                
                pageHelper.showErrors(caseNumber.element.data("invalid"));
                this.clearDMSInfo();
                caseNumber.value("");
                caseNumber.focus();
            }
            else {
                this.getDMSInfo(()=> {
                    this.showDMSInfo(caseNumber, caseNumber.value());
                });
            }
        }
        else {
            this.clearDMSInfo();
        }
    }
    
    onCostTypeSelect = (e) => {
        var invoiceAmount = this.getElement('InvoiceAmount');
        invoiceAmount.data("kendoNumericTextBox").value(e.dataItem.DefaultCost);
    }
}

